import './styles.css';
import React from 'react';
import PropTypes from 'prop-types';
import addScript from '../../utils/addScript';

class EmbeddedYouVisit extends React.Component {
  static propTypes = {
    ipedscode: PropTypes.string,
  };

  componentDidMount() {
    window.vt_initialized = undefined;
    addScript('https://www.youvisit.com/tour/Embed/js2', true, 'you-visit');
  }

  componentWillUnmount() {
    const script = document.getElementById('you-visit');
    script && script.parentNode.removeChild(script);
  }

  // The script will set or keep the link to display: none if no tour is found with the ipedscode,
  // otherwise the script will replace the link with an iframe containing the tour.

  render() {
    const { ipedscode } = this.props;

    return (
      <a
        href="https://www.youvisit.com"
        className="virtualtour_embed"
        title="Virtual Reality, Virtual Tour"
        data-autoplay="0"
        data-hide-buttons="7"
        data-remove-prompts="1"
        data-remove-registration="1"
        data-show-vr="1"
        data-link-type="immersive"
        data-iped={ipedscode}
        data-image-width="100%"
        data-image-height="100%"
        data-platform="powerschool"
        data-hover-width="85%"
        data-hover-height="80%"
        data-cy="youvisit-a"
      >
        Virtual Tour
      </a>
    );
  }
}

export default EmbeddedYouVisit;
